import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martín González',
  location: 'Buenos Aires, CABA',
  text: 'Nunca pude ser constante con mis gastos hasta que probé esta plantilla. Es súper intuitiva y el hecho de que sea en Google Sheets me permite verla desde el celu cuando estoy en la calle. Un 10.',
  rating: 5
}, {
  name: 'Sofía Rodríguez',
  location: 'Córdoba Capital',
  text: "Estaba llena de deudas y no sabía por dónde empezar. El método de 'bola de nieve' que explican en el video tutorial me cambió la cabeza. En 3 meses ya cancelé dos tarjetas.",
  rating: 5
}, {
  name: 'Lucas Martínez',
  location: 'Rosario, Santa Fe',
  text: 'Lo que más me gusta es que no es complicada. Probé apps que te piden vincular el banco y me daban desconfianza. Esto es simple, seguro y lo controlo yo. Recomendadísima.',
  rating: 5
}];
export function Testimonials() {
  return <section className="py-20 bg-white" data-id="element-169">
      <div className="container mx-auto px-4 md:px-6" data-id="element-170">
        <div className="text-center mb-12" data-id="element-171">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-172">
            Lo que dicen quienes ya tomaron el control
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-173">
            Más de 1.000 argentinos ya están ordenando sus finanzas con nuestra
            plantilla.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-174">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-gray-50 p-8 rounded-2xl relative border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-175">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-teal-600/10" data-id="element-176" />

              <div className="flex gap-1 mb-4" data-id="element-177">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" data-id="element-178" />)}
              </div>

              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-179">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3" data-id="element-180">
                <div className="w-10 h-10 rounded-full bg-teal-50 flex items-center justify-center text-teal-600 font-bold text-lg" data-id="element-181">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-182">
                  <h4 className="font-bold text-gray-900 text-sm" data-id="element-183">
                    {testimonial.name}
                  </h4>
                  <p className="text-xs text-gray-500" data-id="element-184">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}